// import aaDev from './env/environments.aa.development.json'
// import exploraDev from './env/environments.explora.development.json'
// import collahuasiDev from './env/environments.collahuasi.development.json'
// import aaPro from './env/environments.aa.production.json'
// import exploraPro from './env/environments.explora.production.json'
// import collahuasiPro from './env/environments.collahuasi.production.json'
import devpronosticosAire from './env/environments.pronosticos_aire.development.json'
import prodpronosticosAire from './env/environments.pronosticos_aire.production.json'

const getEnvironments = () => {
  const currentEnvironment = process.env.NODE_ENV
  const currentAPP = process.env.VUE_APP_CURRENT_APP

  if (currentEnvironment === 'production') {
    switch (currentAPP) {
      case 'pronosticos':
        return prodpronosticosAire
      default:
        return prodpronosticosAire
    }
  } else {
    if (currentEnvironment === 'development') {
      switch (currentAPP) {
        case 'pronosticos':
          return devpronosticosAire
        default:
          return devpronosticosAire
      }
    } else {
      return prodpronosticosAire
    }
  }
}

export { getEnvironments }
